import { TIMELINE } from "@constants/routes/Clients/rocketFactory.routes";

const ROCKETFACTORY = [
  { route: TIMELINE, name: "rocketFactory:common.timeline" },
];

export default ROCKETFACTORY;
